<template>
  <div v-if="hasTexts" class="row mt-5 category-details-info-texts">
    <!-- lower left -->
    <div v-if="category?.value" class="col-12 col-md-6 mb-5 mb-md-0">
      <div class="alert alert-secondary h-100">
        <div class="d-flex align-items-center w-100 text-dark">
          <div>
            <span class="me-1">
              {{
                $t('categoryDetails.description', {
                  categoryTitle: category.title
                })
              }}
            </span>
            <span>
              {{
                $t('groupsComparison.averageForItem', {
                  title: category.title,
                  compareToBenchmark: comparedToBenchmarkText,
                  value: $localeNumber(category.value)
                })
              }}
            </span>
          </div>
        </div>
        <div>
          <ul
            v-if="category.links.length"
            class="list-group list-group-flush mt-10"
          >
            <li
              v-for="link in category.links"
              :key="link"
              class="list-group-item list-group-item-action d-flex align-items-center bg-transparent p-0 hide-fullscreen"
            >
              <button class="btn btn-round btn-sm btn-secondary link-button">
                <a :href="link" target="_blank" class="text-dark">
                  <i class="bi bi-box-arrow-up-right fs-5 text-dark me-2"></i>
                  {{
                    $t('categoryDetails.workWith', {
                      categoryName: category.title
                    })
                  }}
                </a>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- end lower left col -->

    <!-- lower right -->
    <div v-if="currentCategoryTrendDescription" class="col-12 col-md-6">
      <div class="alert alert-secondary h-100">
        <div class="d-flex align-items-center w-100 text-dark">
          {{ currentCategoryTrendDescription }}
        </div>
      </div>
    </div>
    <!-- end lower right col -->
  </div>
</template>

<script>
import { getComparedToBenchmarkText } from '@/helpers/results-helper'
import { getTrendDataForAverages } from '@/helpers/trend-helpers'

export default {
  name: 'CategoryDetailsInfoTexts',
  props: {
    category: {
      type: Object,
      default: () => {}
    },
    currentCategoryHasAtLeastOneZeroToTenQuestion: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasTexts() {
      return this.category?.value || this.currentCategoryTrendDescription
    },
    comparedToBenchmarkText() {
      return getComparedToBenchmarkText({
        t: this.$t,
        tr: this.$tr,
        localeNumber: this.$localeNumber,
        item: this.category
      })
    },
    currentCategoryTrendDescription() {
      if (this.category.averages?.length > 1) {
        const { startDate, endDate, trend } = getTrendDataForAverages({
          averages: this.category.averages,
          regressionValues: this.category.regressionValues
        })
        if (trend) {
          return this.$t(`trendArrow.category.tooltip.trend_${trend}`, {
            categoryName: this.category.title,
            startDate,
            endDate
          })
        } else {
          return this.$t('trendArrow.noTrend')
        }
      }
      return false // this.$t('trendArrow.noTrend')
    }
  }
}
</script>

<style scoped lang="scss">
.link-button > a:hover {
  color: inherit !important;
}
</style>
